import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@/components/ThemeProvider";
import { LanguageProvider } from "@/contexts/LanguageContext";
import AnimatedRoutes from "./components/AnimatedRoutes";
import ErrorBoundary from "@/components/ErrorBoundary";
import { SkipToContent } from "@/components/SkipToContent";

const queryClient = new QueryClient();

import { PWASplashScreen } from "@/components/PWASplashScreen";
import { OfflineBanner } from "@/components/OfflineBanner";

const App = () => (
  <HelmetProvider>
    <ThemeProvider defaultTheme="system">
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <ErrorBoundary>
              <PWASplashScreen />
              <OfflineBanner />
              <SkipToContent />
              <Toaster />
              <Sonner />
              <BrowserRouter>
                <AnimatedRoutes />
              </BrowserRouter>
            </ErrorBoundary>
          </TooltipProvider>
        </QueryClientProvider>
      </LanguageProvider>
    </ThemeProvider>
  </HelmetProvider>
);

export default App;
